import { BEIGE_600, GRAY_900 } from 'constants/styling/theme'
import { FC } from 'react'
import { Stack, Typography } from '@mui/material'

import { AnalyticsEvent } from 'utils/analytics'
import { BorderBoxWrapper } from 'components/common/BorderBoxWrapper/BorderBoxWrapper.component'
import { MUIButton } from 'components/common/MUIButton'
import { StarRatingPopup } from 'components/common/StarRating'
import styles from './ClientGalleryVirtualVisitRating.module.sass'
import { useGalleryAssignment, useStarRatingAnalyticsData } from '../../contexts'
import { useStarRatingEntries } from 'utils/hooks'
import { useTranslation } from 'react-i18next'

interface Props {
  /** Controls the visibility of the rating popup */
  isRatingOpen: boolean
  /** Function to toggle the visibility of the rating popup */
  setIsRatingOpen: (isOpen: boolean) => void
}

/**
 * Client gallery virtual visit Rating component
 * 
 * @example
 * <ClientGalleryVirtualVisitRating />
 */

export const ClientGalleryVirtualVisitRating: FC<Props> = ({
  isRatingOpen,
  setIsRatingOpen
}) => {
  const { t } = useTranslation(['matterport_rating'])

  const {
    logGalleryEvent,
    product,
    assignmentData,
    creative,
  } = useGalleryAssignment()

  const { ratings: initialRatings, isFavouriteCT } = useStarRatingEntries(assignmentData?.id)

  const starRatingAnalyticsData = useStarRatingAnalyticsData()

  const onHandlePopup = (event: AnalyticsEvent) => {
    setIsRatingOpen(!isRatingOpen)
    logGalleryEvent(event, { productKind: product?.kind })
  }

  return (
    <>

      <BorderBoxWrapper
        id="csat-animation"
        backgroundColor={BEIGE_600}
        paddingY={4}
        paddingX={6}
        className={styles.boxShadowPulse}
      >
        <Stack direction="column" alignItems="center">
          <Typography variant="text-md" color={GRAY_900} fontWeight={600} marginBottom={0.4}>{t('rating_cta_title')}</Typography>

          <Typography variant="text-sm" fontWeight="regular" marginBottom={1.6} textAlign='center'>{t('rating_cta_subtitle')}</Typography>

          <MUIButton
            type='secondaryBorder'
            onClick={() => onHandlePopup(AnalyticsEvent.GALLERY_VIRTUAL_VISIT_OPEN_CSAT)}
          >
            {t('rating_cta_button')}
          </MUIButton>
        </Stack>
      </BorderBoxWrapper>

      {assignmentData &&
        <StarRatingPopup
          isOpen={isRatingOpen}
          onClose={() => onHandlePopup(AnalyticsEvent.GALLERY_VIRTUAL_VISIT_CLOSE_CSAT)}
          assignmentId={assignmentData.id}
          hasCreative={!!creative}
          creativeName={creative?.name}
          initialRatings={initialRatings}
          initialIsFavouriteCT={isFavouriteCT}
          analyticsData={starRatingAnalyticsData}
        />
      }

    </>
  )
}
